import { AutoMap } from "@automapper/classes";
import { EInterventionStatus } from "src/app/domain/enums/intervention-status";
import { ETimeSlot } from "src/app/domain/enums/time-slot";
import { MeasureEauDTO } from "./measure-eau.dto";
import { MeasureLingetteDTO } from "./measure-lingette.dto";
import { MeasureMassifDTO } from "./measure-massif.dto";
import { ProcessDTO } from "./process.dto";
import { SamplingPointDTO } from "./sampling-point.dto";
import { UserDTO } from "./user.dto";
import { ZoneDTO } from "./zone.dto";
import { AreaMapDTO } from "./area-map.dto";
import { MesureAdductionDTO } from "./mesure-adduction.dto";
import { MeasureGenericDTO } from "./measure-generic.dto";

export class InterventionDTO {

    /** ID SERVER */
    @AutoMap()
    code!: number;
    @AutoMap()
    status!: EInterventionStatus;
    @AutoMap()
    comment?: string;
    @AutoMap()
    plannedOn!: string;
    @AutoMap()
    plannedTimeSlot!: ETimeSlot;

    @AutoMap()
    samplingPoint: SamplingPointDTO = new SamplingPointDTO();
    @AutoMap()
    sampler: UserDTO = new UserDTO();
    @AutoMap()
    contact: UserDTO = new UserDTO();
    @AutoMap(() => [ZoneDTO])
    zoneList: ZoneDTO[] = [];

    @AutoMap(() => [ProcessDTO])
    processList: ProcessDTO[] = [];

    @AutoMap(() => [MeasureEauDTO])
    mesureEauList: MeasureEauDTO[] = [];

    @AutoMap(() => [MeasureMassifDTO])
    mesureMassifList: MeasureMassifDTO[] = [];

    @AutoMap(() => [MeasureLingetteDTO])
    mesureLingetteList: MeasureLingetteDTO[] = [];

    @AutoMap(() => [MesureAdductionDTO])
    mesureAdductionAirList: MesureAdductionDTO[] = []
    @AutoMap(() => [MeasureGenericDTO])
    mesureGeneriqueList: MeasureGenericDTO[] = []
    @AutoMap()
    situationPlan?: AreaMapDTO;
    @AutoMap()
    strategyId!: number;
    @AutoMap()
    redactor!: string
    @AutoMap()
    clientName!: string

    @AutoMap(() => [AreaMapDTO])
    lingetteAreaMapTerrainList: AreaMapDTO[] = [];
    @AutoMap(() => [AreaMapDTO])
    massifAreaMapTerrainList: AreaMapDTO[] = [];
}